export const activities = [
  {
    id: 1,
    name: "Maidu Regional Park",
    category: "Parks & Nature",
    description: "152-acre park featuring trails, playgrounds, sports fields, and the Maidu Museum & Historic Site showcasing Native American heritage.",
    image: "https://public.readdy.ai/ai/img_res/ab82a15cbc18f9b62d1e2a851fa1f1a2.jpg",
    address: "1600 Johnson Ranch Dr, Roseville, CA 95661",
    hours: "6:00 AM - Sunset",
    amenities: ["Trails", "Playground", "Sports Fields", "Museum", "Picnic Areas"]
  },
  {
    id: 2,
    name: "Roseville Aquatics Complex",
    category: "Sports & Fitness",
    description: "State-of-the-art aquatic facility with Olympic-size pool, diving boards, water slides, and splash pad. Perfect for families and competitive swimmers.",
    image: "https://readdy.ai/api/search-image?query=modern%20outdoor%20aquatic%20center%20with%20olympic%20swimming%20pool%20water%20slides%20and%20splash%20pad%20under%20sunny%20california%20sky%20family%20recreation%20facility%20with%20blue%20water%20and%20poolside%20amenities%20bright%20cheerful%20atmosphere&width=800&height=600&seq=aquatics-complex-001&orientation=landscape",
    address: "1600 Cirby Way, Roseville, CA 95661",
    hours: "Mon-Sun: 12:00 PM - 6:00 PM (Seasonal)",
    amenities: ["Olympic Pool", "Water Slides", "Diving Boards", "Splash Pad", "Lap Swimming"]
  },
  {
    id: 3,
    name: "Golfland Sunsplash",
    category: "Entertainment",
    description: "Ultimate family entertainment destination with water park, mini golf, go-karts, laser tag, and arcade games. Summer fun for all ages!",
    image: "https://readdy.ai/api/search-image?query=vibrant%20family%20entertainment%20center%20with%20colorful%20water%20park%20slides%20mini%20golf%20course%20and%20go%20kart%20track%20sunny%20day%20with%20happy%20families%20enjoying%20outdoor%20activities%20bright%20playful%20atmosphere%20with%20palm%20trees&width=800&height=600&seq=golfland-sunsplash-001&orientation=landscape",
    address: "1893 Taylor Rd, Roseville, CA 95661",
    hours: "Mon-Thu: 11:00 AM - 9:00 PM, Fri-Sun: 10:00 AM - 10:00 PM",
    amenities: ["Water Park", "Mini Golf", "Go-Karts", "Laser Tag", "Arcade"]
  },
  {
    id: 4,
    name: "Roseville Sports Center",
    category: "Sports & Fitness",
    description: "Premier indoor sports facility offering basketball, volleyball, pickleball courts, and fitness classes. Host to tournaments and leagues year-round.",
    image: "https://readdy.ai/api/search-image?query=modern%20indoor%20sports%20facility%20with%20basketball%20courts%20volleyball%20nets%20and%20fitness%20equipment%20bright%20spacious%20gymnasium%20with%20high%20ceilings%20and%20professional%20athletic%20flooring%20clean%20contemporary%20design&width=800&height=600&seq=sports-center-001&orientation=landscape",
    address: "1545 Pleasant Grove Blvd, Roseville, CA 95747",
    hours: "Mon-Fri: 5:00 AM - 10:00 PM, Sat-Sun: 7:00 AM - 8:00 PM",
    amenities: ["Basketball Courts", "Volleyball", "Pickleball", "Fitness Classes", "Tournaments"]
  },
  {
    id: 5,
    name: "Miner's Ravine Trail Loop",
    category: "Parks & Nature",
    description: "Scenic 3.5-mile paved trail perfect for walking, jogging, and cycling. Features beautiful creek views, wildlife, and connects multiple parks.",
    image: "https://readdy.ai/api/search-image?query=peaceful%20paved%20walking%20trail%20through%20natural%20ravine%20with%20creek%20flowing%20alongside%20lush%20green%20trees%20and%20vegetation%20cyclists%20and%20joggers%20enjoying%20scenic%20outdoor%20path%20serene%20nature%20setting&width=800&height=600&seq=miners-ravine-001&orientation=landscape",
    address: "Access points throughout Roseville",
    hours: "Dawn to Dusk",
    amenities: ["Paved Trail", "Creek Views", "Wildlife", "Bike Friendly", "Dog Friendly"]
  },
  {
    id: 6,
    name: "Topgolf Roseville",
    category: "Entertainment",
    description: "High-tech golf entertainment venue with climate-controlled hitting bays, food & drinks, and games for all skill levels. Great for groups and events.",
    image: "https://readdy.ai/api/search-image?query=modern%20topgolf%20entertainment%20venue%20with%20multiple%20hitting%20bays%20and%20targets%20on%20driving%20range%20evening%20atmosphere%20with%20ambient%20lighting%20people%20enjoying%20golf%20games%20and%20socializing%20contemporary%20sports%20entertainment%20facility&width=800&height=600&seq=topgolf-roseville-001&orientation=landscape",
    address: "1700 Freedom Way, Roseville, CA 95678",
    hours: "Mon-Thu: 10:00 AM - 11:00 PM, Fri-Sat: 10:00 AM - 1:00 AM, Sun: 10:00 AM - 11:00 PM",
    amenities: ["Golf Bays", "Restaurant", "Bar", "Private Events", "Games"]
  },
  {
    id: 7,
    name: "Denio's Farmers Market & Swap Meet",
    category: "Shopping & Markets",
    description: "Northern California's largest outdoor market with 1,000+ vendors selling fresh produce, antiques, crafts, and more. Open weekends year-round.",
    image: "https://readdy.ai/api/search-image?query=bustling%20outdoor%20farmers%20market%20with%20colorful%20vendor%20stalls%20selling%20fresh%20produce%20flowers%20and%20handmade%20crafts%20sunny%20day%20with%20crowds%20of%20shoppers%20browsing%20vibrant%20market%20atmosphere%20with%20tents%20and%20displays&width=800&height=600&seq=denios-market-001&orientation=landscape",
    address: "1551 Vineyard Rd, Roseville, CA 95678",
    hours: "Sat-Sun: 7:00 AM - 3:00 PM",
    amenities: ["Fresh Produce", "Antiques", "Crafts", "Food Vendors", "Free Parking"]
  },
  {
    id: 8,
    name: "Roseville Skating Center",
    category: "Entertainment",
    description: "Family-friendly roller skating rink offering public sessions, lessons, and birthday parties. Classic fun with modern music and lights!",
    image: "https://readdy.ai/api/search-image?query=indoor%20roller%20skating%20rink%20with%20colorful%20disco%20lights%20and%20families%20skating%20together%20polished%20wooden%20floor%20with%20skaters%20enjoying%20music%20and%20fun%20retro%20entertainment%20venue%20with%20vibrant%20atmosphere&width=800&height=600&seq=skating-center-001&orientation=landscape",
    address: "1009 Orlando Ave, Roseville, CA 95661",
    hours: "Wed-Thu: 7:00 PM - 9:00 PM, Fri: 7:00 PM - 11:00 PM, Sat-Sun: 1:00 PM - 9:00 PM",
    amenities: ["Roller Skating", "Lessons", "Birthday Parties", "Snack Bar", "Arcade"]
  },
  {
    id: 9,
    name: "Mahany Park",
    category: "Parks & Nature",
    description: "Beautiful 42-acre community park featuring a lake, amphitheater, skate park, and extensive playground. Host to many city events and concerts.",
    image: "https://readdy.ai/api/search-image?query=scenic%20community%20park%20with%20peaceful%20lake%20surrounded%20by%20green%20grass%20and%20trees%20modern%20playground%20equipment%20and%20walking%20paths%20families%20enjoying%20outdoor%20recreation%20beautiful%20california%20park%20setting&width=800&height=600&seq=mahany-park-001&orientation=landscape",
    address: "1545 Pleasant Grove Blvd, Roseville, CA 95747",
    hours: "6:00 AM - 10:00 PM",
    amenities: ["Lake", "Amphitheater", "Skate Park", "Playground", "Event Space"]
  },
  {
    id: 10,
    name: "Strikes Unlimited",
    category: "Entertainment",
    description: "Modern bowling center with 40 lanes, arcade games, laser tag, and full-service restaurant. Perfect for leagues, parties, and family fun.",
    image: "https://readdy.ai/api/search-image?query=contemporary%20bowling%20alley%20interior%20with%20multiple%20lanes%20colorful%20lighting%20and%20modern%20scoring%20screens%20people%20bowling%20and%20having%20fun%20sleek%20entertainment%20venue%20with%20arcade%20games%20in%20background&width=800&height=600&seq=strikes-unlimited-001&orientation=landscape",
    address: "5681 Lonetree Blvd, Rocklin, CA 95765",
    hours: "Mon-Thu: 11:00 AM - 11:00 PM, Fri-Sat: 11:00 AM - 1:00 AM, Sun: 11:00 AM - 11:00 PM",
    amenities: ["Bowling", "Arcade", "Laser Tag", "Restaurant", "Party Rooms"]
  },
  {
    id: 11,
    name: "Roseville Utility Exploration Center",
    category: "Education & Culture",
    description: "Interactive museum showcasing Roseville's water and electric utilities through hands-on exhibits. Free admission and educational programs for all ages.",
    image: "https://readdy.ai/api/search-image?query=modern%20interactive%20science%20museum%20interior%20with%20educational%20exhibits%20about%20water%20and%20electricity%20hands%20on%20displays%20and%20children%20learning%20bright%20engaging%20educational%20environment%20with%20technology%20demonstrations&width=800&height=600&seq=utility-center-001&orientation=landscape",
    address: "1501 Pleasant Grove Blvd, Roseville, CA 95747",
    hours: "Tue-Sat: 10:00 AM - 5:00 PM",
    amenities: ["Interactive Exhibits", "Free Admission", "Educational Programs", "Gift Shop", "Group Tours"]
  },
  {
    id: 12,
    name: "Woodcreek Oaks Golf Club",
    category: "Sports & Fitness",
    description: "Championship 18-hole golf course designed by Brad Bell. Features challenging layout, pro shop, and clubhouse with dining. Open to the public.",
    image: "https://readdy.ai/api/search-image?query=pristine%20golf%20course%20with%20manicured%20green%20fairways%20sand%20bunkers%20and%20water%20hazards%20under%20clear%20blue%20sky%20golfers%20on%20course%20with%20rolling%20hills%20and%20trees%20professional%20championship%20golf%20club%20setting&width=800&height=600&seq=woodcreek-golf-001&orientation=landscape",
    address: "5880 Woodcreek Oaks Blvd, Roseville, CA 95747",
    hours: "Daily: 6:30 AM - Sunset",
    amenities: ["18-Hole Course", "Pro Shop", "Driving Range", "Restaurant", "Golf Lessons"]
  }
];

export const activityCategories = [
  "All Activities",
  "Parks & Nature",
  "Sports & Fitness",
  "Entertainment",
  "Shopping & Markets",
  "Education & Culture"
];